import { isSSR } from '@k2/core/util'
import type { NavigationGuardWithThis, RouteLocationNormalized, RouteLocationRaw } from 'vue-router'
import { useOrganizationStore } from '../store'

// Convenience, never the boundary: the API resolves membership itself and answers
// 404 for an organization the caller is not in (`ARCHITECTURE.md` §3.1).
export const organizationGuard: NavigationGuardWithThis<undefined> = async (to: RouteLocationNormalized) => {
  if (isSSR) return true

  const store = useOrganizationStore()
  await store.load()

  const organizationId = to.params.organizationId
  if (store.organizations.some(organization => organization.id === organizationId)) return true

  return { name: 'organizations' } as RouteLocationRaw
}
